import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import ReactGA from 'react-ga';

// Utils.
import { isWebviewApp } from 'utils';

// Styles.
import styles from './styles.module.scss';

@withRouter
export default class AuthClearContainer extends Component {

  static propTypes = {
    location: PropTypes.object.isRequired,
    content: PropTypes.element,
    children: PropTypes.element,
  };

  static defaultProps = {
    theme: 'light',
    isFree: false,
  };

  componentDidMount() {
    const path = `${window.location.pathname}`;
    ReactGA.pageview(path);
  }

  render() {
    const {
      content,
      children,
      theme,
    } = this.props;

    const isWebviewAppStatus = isWebviewApp();
    return (
      <div className={cx(styles.wrapper, { [styles.isWebView]: isWebviewAppStatus }, { [styles.themeDark]: theme === 'ink' })}>
        <div id="content" className={styles.content}>
          <div className={cx(styles.contentWrapper, { [styles.isWebView]: isWebviewAppStatus })}>
              {content || children}
          </div>
        </div>
      </div>
    );
  }

}
